import React from "react"
import { ScrollReveal } from "../ui/scroll-reveal"
import { Award, Sparkles, Rocket, Clock } from "lucide-react"

const differentiators = [
  {
    title: "Proven ROI",
    description: "We deliver tangible results - AI solutions with measurable impact from day one.",
    icon: Award,
  },
  {
    title: "Rapid Capability Building",
    description: "Through structured training and custom Partner AIs, your teams gain skills and tools that scale.",
    icon: Sparkles,
  },
  {
    title: "Accelerated Delivery",
    description: "We achieve significant time savings through AI-enhanced workflows - often cutting development cycles in half whilst delivering substantial operational gains.",
    icon: Rocket,
  },
  {
    title: "Immediate Impact",
    description: "Our practical, hands-on approach means outcomes aren't theoretical - they're real, visible, and aligned to your goals.",
    icon: Clock,
  },
]

export function WhyChooseSection() {
  return (
    <section className="py-16">
      <div className="container space-y-12">
        <ScrollReveal>
          <div className="text-center space-y-4">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl">Why Choose Syllepsis</h2>
          </div>
        </ScrollReveal>
        
        <ScrollReveal>
          <div className="max-w-4xl mx-auto space-y-6">
            <p className="text-lg">
              At Syllepsis, we're not here to theorise. We're here to deliver. Our work is built
              around a simple promise: practical AI solutions that drive measurable
              outcomes...fast.
            </p>
            
            <p className="text-lg">
              We combine strategic clarity with rapid implementation, helping ambitious teams
              unlock the real potential of AI - not in months, but in weeks. Every engagement is
              tailored, every solution is actionable and every outcome is tracked.
            </p>
            
            <div className="pt-4">
              <h3 className="text-xl font-semibold mb-4">Here's what sets us apart:</h3>
              
              <ul className="space-y-6">
                {differentiators.map((item) => (
                  <li key={item.title} className="flex gap-4">
                    <div className="mt-1 flex-shrink-0">
                      <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                        <item.icon className="w-4 h-4 text-primary" strokeWidth={2} />
                      </div>
                    </div>
                    <div>
                      <h4 className="text-lg font-medium">{item.title}</h4>
                      <p className="text-muted-foreground">{item.description}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            
            <p className="text-xl pt-6">
              At Syllepsis, we don't just advise. <strong>We implement, we guide and we
              deliver... fast.</strong>
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>
  )
} 